<template>
  <div
    class="icon-wrapper btn--circle">
    <span class="icon material-icons text-blue">
      {{ icon }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'l-blue'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-wrapper {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 2px 6px $grey05;
  background-color: $white;
}

.icon {
  color: $l-blue;
}
</style>